import React from 'react'

import cx from 'classnames'

import Shimmer from './Shimmer'

export enum Theme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export enum Size {
  SMALL = 'SMALL',
  RANDOM = 'RANDOM',
}

interface Props {
  size: Size
  theme: Theme
  count: number
  containerClassName?: string
  itemClassName: string
}

const LoadingState: React.FC<Props> = ({
  size,
  theme,
  count,
  containerClassName,
  itemClassName,
}): JSX.Element => (
  <div className={cx(containerClassName)}>
    {[...Array(count)].map((_, i) => (
      <Shimmer index={i} key={i} className={itemClassName} theme={theme} size={size} />
    ))}
  </div>
)

export default React.memo(LoadingState)
